<ul class="pagination">
  <li
    *ngFor="let page of pages"
    class="page-item"
    [ngClass]="{active: currentPageProps === page}"
  >
    <a [routerLink]="[urlProps]" [queryParams]="{page: page}" class="page-link">
      {{ page }}
    </a>
  </li>
</ul>
